var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 29.999,
    viewBox: "0 0 30 29.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.99,30a3,3,0,1,1,3-3A2.995,2.995,0,0,1,23.99,30ZM9,30a3,3,0,1,1,3-3A2.995,2.995,0,0,1,9,30ZM26.99,22.5H9a2.965,2.965,0,0,1-2.57-1.463,3,3,0,0,1-.054-2.992L8.4,14.385,3,3H0V0H4.9L6.313,3H28.5A1.495,1.495,0,0,1,29.809,5.22L24.44,14.955A2.984,2.984,0,0,1,21.817,16.5H10.646L9,19.5H26.99v3ZM7.737,6l3.554,7.5H21.817L25.955,6H7.737Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCart);
export default __webpack_public_path__ + "static/media/icon-cart.1961399342b34b2335e17f433e5f5fb7.svg";
export { ForwardRef as ReactComponent };